import { TextField } from '@monorepo/shared/componentsV2/fields/TextField';
import { Main } from '@monorepo/shared/componentsV2/Main';
import { focusOutline } from '@monorepo/shared/styles/focus';
import {
  contentPadding,
  fillHeightAndScrollable,
  page,
  verticalLayout,
} from '@monorepo/shared/styles/layout';
import styled from 'styled-components';

export const StyledMain = styled(Main)`
  ${page}
  ${verticalLayout}
`;

export const ColumnWrapper = styled.div`
  position: fixed;
  top: 72px;
  display: flex;
  flex-flow: row;
  width: 100%;
  height: 100%;
`;

export const MainContent = styled.div`
  ${contentPadding}
  ${fillHeightAndScrollable}
  width: 70%;
  padding-bottom: 72px;
  margin-right: 4rem;
`;

export const Sidebar = styled.div<{ $sidebarWidth?: string }>`
  ${contentPadding}
  ${fillHeightAndScrollable}
  display: flex;
  flex-direction: column;
  width: ${({ $sidebarWidth }) => $sidebarWidth || '30%'};
  min-width: 300px;
  padding-bottom: 72px;
  color: ${({ theme }) => theme.colors.gray333};
  background-color: ${({ theme }) => theme.colors.grayf6};
`;

export const SectionButton = styled.button`
  width: 100%;
  padding: 1rem;
  font-size: 1rem;
  text-align: left;
  overflow-wrap: anywhere;
  background-color: ${({ theme }) => theme.colors.white};
  border-color: ${({ theme }) => theme.colors.grayddd};
  border-style: solid;
  border-radius: 0.5rem;
  outline: none;

  &:hover {
    cursor: pointer;
  }

  &.active {
    font-weight: 700;
    background-color: #eaeaea;
  }

  &:focus-visible {
    ${focusOutline()}
  }
`;

export const AddSectionButton = styled(SectionButton)`
  display: flex;
  gap: 0.75rem;
  align-items: center;
  justify-content: center;
  margin-bottom: 1rem;
  font-size: 14px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.gray333};
  background-color: ${({ theme }) => theme.colors.white};
  border-color: ${({ theme }) => theme.colors.graybbb};
  border-style: dashed;

  &:hover {
    background-color: ${({ theme }) => theme.colors.grayf6};
  }

  &:active {
    background-color: ${({ theme }) => theme.colors.grayf4};
  }

  &:disabled {
    background-color: ${({ theme }) => theme.colors.grayf6};
    opacity: 0.7;
  }
`;

export const ModalFieldWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  max-width: 50rem;
  margin: 0 0 0.1rem;

  & fieldset {
    width: 100%;
  }
`;

export const ModalTextField = styled(TextField)`
  width: 50rem;
`;
